const base = import.meta.env.VITE_IMAGE_BASE_URL ?? 'https://coupon-relay.s3.ap-northeast-2.amazonaws.com';

export const IMAGE_BASE = base.replace(/\/+$/, '');
